<template>
  <div>
    <el-row class="title-bar title-h3">{{title}} 자원설정</el-row>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <!-- 0412 width 변경-최저해상도 -->
        <el-select class="mr-r4" v-model="managetypeId" style="width:115px;">
          <el-option v-for="item in managetypeList" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId"></el-option>
        </el-select>
        <el-select class="mr-r4" v-show="managetypeId=='NMS'||managetypeId=='FMS'||managetypeId=='DBMS'||managetypeId=='VMS'" v-model="managetypeKey" style="width:145px;">
          <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.managetypeKeyName" :value="item.managetypeKey"></el-option>
        </el-select>
        <el-radio-group class="ordinary setting mr-r4" v-model="resourceType" @change="loadData" size="small">
          <el-radio-button label="RSCTYPE">자원구분</el-radio-button>
          <el-radio-button label="RSC">자원</el-radio-button>
        </el-radio-group>
        <el-button class="mr-r4" size="mini" @click="clickEventRscGetintervalButton">이벤트 판단 주기</el-button>
        <div class="vertical-center-box mr-l4" v-show="resourceType === 'RSCTYPE'">
        <span class="mr-r5">적용여부</span>
        <div class="setting-addel">
          <!-- add 1210 height ie friendly -->
          <el-button size="mini" style="height:27px" @click="onCollectAll(true)"><i class="fas fa-check-square"></i></el-button>
          <el-button size="mini" style="height:27px" @click="onCollectAll(false)"><i class="far fa-square"></i></el-button>
        </div>
        </div>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" v-show="resourceType == 'RSCTYPE'" size="mini" type="primary" @click="clickSaveButton" :disabled="!rsctypeDataChangeFlag">저장</el-button>
        <el-button class="mr-r4" v-show="resourceType == 'RSCTYPE'" size="mini" @click="clickCancelButton" :disabled="!rsctypeDataChangeFlag">취소</el-button>
        <el-button class="mr-r4" size="mini" @click="exportExcel">
          <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
          <span style="left:2px;bottom:5px;">  엑셀출력</span>
        </el-button>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <!-- 자원구분 -->
    <el-table-wrapper v-loading="rsctypeLoading" :element-loading-text="rsctypeLoadingText" v-show="resourceType == 'RSCTYPE'" :data="ruleRsctypeTableData" :columns="ruleRsctypeTableColumn" ref="ruleRsctypeTable" row-class-name="c-dblclick"
    highlight-current-row @row-dblclick="dblclickRow" :pagination="true" style="width:100%;" :show-search-tool="showSearchTool"
     :show-custom-header="true" :column-default="columnDefault" @condition-change="changeTableCondition" remote :total="total">
      <template slot-scope="scope" slot="switch-slot">
        <!-- add style 1207 ie friendly -->
        <el-switch class="switch-exceptional" v-model="scope.row.applyFlag" active-value="Y" inactive-value="N" @change="changeApplystatFlag"></el-switch>
        <!-- end 1207 -->
      </template>
    </el-table-wrapper>
    <!-- 자원 -->
    <el-table-wrapper v-loading="rscLoading" :element-loading-text="rscLoadingText" v-show="resourceType == 'RSC'" :data="ruleRscTableData" :columns="ruleRscTableColumn" ref="ruleRscTable" row-class-name="c-dblclick"
    highlight-current-row @row-dblclick="dblclickRow" :pagination="true" style="width:100%;" :show-search-tool="showSearchTool"
    :show-custom-header="true" :column-default="columnDefault" @condition-change="changeTableCondition" remote :total="total">
      <template slot-scope="scope" slot="switch-slot">
        <el-switch v-model="scope.row.applyFlag" active-value="Y" inactive-value="N" @change="changeApplystatFlag"></el-switch>
      </template>
    </el-table-wrapper>
    <w-update-rule-rsctype-popup ref="updateRuleRsctypePopup" :update-row="updateRow" :managetype-id="managetypeId" :managetype-key="managetypeKey" @re-load="loadData"></w-update-rule-rsctype-popup>
    <w-update-rule-rsc-popup sliding-popup-type="setting" ref="updateRuleRscPopup" :update-row="updateRow" :managetype-id="managetypeId" :managetype-key="managetypeKey" @re-load="loadData"></w-update-rule-rsc-popup>
    <w-event-rsc-getinterval-setting-popup ref="eventRscGetintervalSettingpopup"></w-event-rsc-getinterval-setting-popup>
  </div>
</template>

<script>
import differenceWith from 'lodash/differenceWith';
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import msgUtil from '@/utils/message';
import ManagetypeKeyAPI from '@/api/model/managetype-key';
import RuleSettingsAPI from '@/api/settings/common/rule-settings';
import FileApi from '@/api/common/file';
import { columnDefault } from '@/constants/table';
import WUpdateRuleRsctypePopup from '../popup/UpdateRuleRsctypePopup';
import WUpdateRuleRscPopup from '../popup/UpdateRuleRscPopup';
import WEventRscGetintervalSettingPopup from '../popup/EventRscGetintervalSettingPopup';

export default {
  name: 'WRuleResourceTable',
  components: {
    WUpdateRuleRsctypePopup,
    WUpdateRuleRscPopup,
    WEventRscGetintervalSettingPopup,
  },
  props: {
    managetypeList: Array,
    selectedRule: Object,
  },
  data() {
    return {
      rsctypeLoading: false,
      rsctypeLoadingText: null,
      rscLoading: false,
      rscLoadingText: null,
      columnDefault,
      managetypeId: null,
      managetypeKey: null,
      managetypeIdKey: null,
      managetypeKeyList: [],
      title: null,
      resourceType: 'RSCTYPE',
      showSearchTool: false,
      selectedRuleResourceRow: null,
      updateRow: null,
      total: 0,
      ruleRsctypeTableData: [],
      ruleRsctypeTableOriginData: [],
      ruleRscTableData: [],
      rsctypeDataChangeFlag: false,
      ruleRsctypeTableColumn: [
        {
          prop: 'applyFlag',
          label: '적용',
          width: 80,
          scopedSlot: 'switch-slot',
          filters: [
            {
              text: '적용',
              value: 'Y',
            },
            {
              text: '해제',
              value: 'N',
            },
          ],
        },
        {
          prop: 'rsctypeId',
          label: '자원구분 아이디',
          searchable: true,
        },
        {
          prop: 'rsctypeName',
          label: '자원구분명',
          searchable: true,
        },
        {
          prop: 'rscGetinterval',
          label: '수집 주기(초)',
          searchable: true,
        },
        {
          prop: 'eventRscGetintervalName',
          label: '이벤트 판단 주기',
          searchable: true,
        },
        {
          prop: 'eventJudgeCount',
          label: '판단 횟수',
          searchable: true,
        },
        {
          prop: 'rscGetmethodName',
          label: '수집 방식',
          searchable: true,
        },
      ],
      ruleRscTableColumn: [
        {
          prop: 'rsctypeName',
          label: '자원구분명',
          searchable: true,
        },
        {
          prop: 'rscId',
          label: '자원 아이디',
          searchable: true,
        },
        {
          prop: 'rscName',
          label: '자원명',
          searchable: true,
        },
        {
          prop: 'rscUnit',
          label: '자원단위',
          searchable: true,
        },
        {
          prop: 'eventJudgeConditionTypeName',
          label: '이벤트 판단 타입',
          searchable: true,
        },
        {
          prop: 'rscGetmethodName',
          label: '수집 방식',
          searchable: true,
        },
      ],
    };
  },
  watch: {
    managetypeList: {
      immediate: true,
      handler(array) {
        if (!isNil(array)) {
          if (isNil(this.managetypeId)) {
            this.managetypeId = array[0].managetypeId;
          }
        }
      },
    },
    managetypeId: {
      immediate: true,
      handler(value) {
        this.selectedRuleResourceRow = null;
        if (!isNil(value)) {
          ManagetypeKeyAPI.getDisplayedManagetypeKeyList(value).then((response) => {
            if (response.data.success) {
              if ((isEqual(value, 'NMS') || isEqual(value, 'FMS') || isEqual(value, 'DBMS') || isEqual(value, 'VMS'))) {
                this.managetypeKeyList = response.data.data;
                this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
              } else {
                this.managetypeKey = '_';
              }
              this.managetypeIdKey = `${value}.${this.managetypeKey}`;
            } else {
              this.managetypeKeyList = [];
              this.managetypeKey = null;
            }
          }).catch(() => {
            this.managetypeKeyList = [];
            this.managetypeKey = null;
          });
          if (!isNil(this.$refs.ruleRsctypeTable)) {
            this.$refs.ruleRsctypeTable.clearFilter();
          }
          if (!isNil(this.$refs.ruleRscTable)) {
            this.$refs.ruleRscTable.clearFilter();
          }
        }
      },
    },
    managetypeKey: {
      immediate: true,
      handler(value) {
        const managetypeId = this.managetypeId;
        this.managetypeIdKey = `${managetypeId}.${value}`;
      },
    },
    managetypeIdKey: {
      immediate: true,
      handler(value) {
        this.selectedRuleResourceRow = null;
        if (!isNil(value) && !isNil(this.selectedRule)) {
          if (!isNil(this.$refs.ruleRsctypeTable)) {
            this.$refs.ruleRsctypeTable.clearFilter();
          }
          if (!isNil(this.$refs.ruleRsctypeTable)) {
            this.$refs.ruleRscTable.clearFilter();
          }
          this.loadRuleData();
        }
      },
    },
    selectedRule: {
      immediate: true,
      handler(object) {
        if (!isNil(object)) {
          this.title = object.ruleTmplName;
          if (!isNil(this.managetypeIdKey)) {
            if (!isNil(this.$refs.ruleRsctypeTable)) {
              this.$refs.ruleRsctypeTable.clearFilter();
            }
            if (!isNil(this.$refs.ruleRsctypeTable)) {
              this.$refs.ruleRscTable.clearFilter();
            }
            this.loadRuleData();
          }
        }
      },
    },
  },
  methods: {
    loadRuleData() {
      const table = isEqual(this.resourceType, 'RSCTYPE') ? this.$refs.ruleRsctypeTable : this.$refs.ruleRscTable;
      if (table) {
        this.loadData();
      } else {
        this.$nextTick(() => {
          this.loadData();
        });
      }
    },
    loadData() {
      const params = this.getParameter();
      if (isEqual(this.resourceType, 'RSCTYPE')) {
        this.rsctypeLoadingText = null;
        this.rsctypeLoading = true;
        RuleSettingsAPI.getRuleRsctypeList(params).then((response) => {
          if (response.data.success) {
            this.total = response.data.total;
            this.ruleRsctypeTableData = cloneDeep(response.data.data);
            this.ruleRsctypeTableOriginData = cloneDeep(response.data.data);
            this.$nextTick(() => {
              this.changeApplystatFlag();
            });
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 설정', false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 설정', false));
        }).finally(() => {
          this.rsctypeLoading = false;
        });
      } else {
        this.rscLoadingText = null;
        this.rscLoading = true;
        RuleSettingsAPI.getRuleRscList(params).then((response) => {
          if (response.data.success) {
            this.total = response.data.total;
            this.ruleRscTableData = cloneDeep(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 설정', false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 설정', false));
        }).finally(() => {
          this.rscLoading = false;
        });
      }
    },
    /**
     * 정책 조회를 위한 파라미터 객체를 생성하여 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getParameter() {
      const managetypeId = this.managetypeId;
      const managetypeKey = this.managetypeKey;
      const tableParams = isEqual(this.resourceType, 'RSCTYPE') ? this.$refs.ruleRsctypeTable.getParameter() : this.$refs.ruleRscTable.getParameter();
      return {
        managetypeId,
        managetypeKey,
        ruleTmplId: this.selectedRule.ruleTmplId,
        ...tableParams,
      };
    },
    dblclickRow(row) {
      this.updateRow = cloneDeep(row);
      if (isEqual(this.resourceType, 'RSCTYPE')) {
        this.$refs.updateRuleRsctypePopup.$refs.slidingPopup.visible = true;
      } else {
        this.$refs.updateRuleRscPopup.$refs.slidingPopup.visible = true;
      }
    },
    clickSaveButton() {
      RuleSettingsAPI.updateRuleRsctypeList(differenceWith(this.ruleRsctypeTableData, this.ruleRsctypeTableOriginData, isEqual)).then((response) => {
        if (response.data.success) {
          this.loadData();
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '정책 자원설정', true));
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '정책 자원설정', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '정책 자원설정', false));
      });
    },
    clickCancelButton() {
      this.loadData();
      this.$message(msgUtil.getCustomResultMsgData('변경사항이 취소되었습니다.', true));
    },
    changeApplystatFlag() {
      this.rsctypeDataChangeFlag = !isEqual(this.ruleRsctypeTableData, this.ruleRsctypeTableOriginData);
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    clickEventRscGetintervalButton() {
      this.$refs.eventRscGetintervalSettingpopup.$refs.slidingPopup.visible = true;
    },
    changeTableCondition() {
      this.loadData();
    },
    onCollectAll(value) {
      if (value) {
        // true : 전체 선택
        if (this.resourceType === 'RSCTYPE') {
          this.ruleRsctypeTableData.forEach((item) => {
            item.applyFlag = 'Y';
          });
        } else {
          this.ruleRsctypeTableData.forEach((item) => {
            item.applyFlag = 'Y';
          });
        }
      } else if (this.resourceType === 'RSCTYPE') {
        this.ruleRsctypeTableData.forEach((item) => {
          item.applyFlag = 'N';
        });
      } else {
        this.ruleRsctypeTableData.forEach((item) => {
          item.applyFlag = 'N';
        });
      }
      this.changeApplystatFlag();
    },
    /**
     * 조회한 정책 정보를 엑셀 파일로 출력한다.
     * @author Ju
     * @return {[type]} [description]
     */
    exportExcel() {
      const params = this.getParameter();
      delete params.start;
      delete params.limit;

      let excelFunction;
      if (isEqual(this.resourceType, 'RSCTYPE')) {
        excelFunction = RuleSettingsAPI.createRuleRsctypeExcel;
        this.rsctypeLoadingText = '엑셀 출력 중..';
        this.rsctypeLoading = true;
      } else {
        excelFunction = RuleSettingsAPI.createRuleRscExcel;
        this.rscLoadingText = '엑셀 출력 중..';
        this.rscLoading = true;
      }
      excelFunction(params).then((response) => {
        if (response.data.success && !isNil(response.data.data)) {
          FileApi.downloadExportedExcelFile(response.data.data);
        } else {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
      }).finally(() => {
        if (isEqual(this.resourceType, 'RSCTYPE')) {
          this.rsctypeLoadingText = null;
          this.rsctypeLoading = false;
        } else {
          excelFunction = RuleSettingsAPI.createRuleRscExcel;
          this.rscLoadingText = null;
          this.rscLoading = false;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/components/RuleResourceTable.vue